import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export interface SelectOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  width?: 'sm' | 'md' | 'lg' | 'full';
}

const widthClasses = {
  sm: 'w-24',
  md: 'w-32',
  lg: 'w-40',
  full: 'w-full'
} as const;

function FilterSelect({
  label,
  value,
  onChange,
  options,
  placeholder,
  className = '',
  width = 'md'
}: FilterSelectProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && <label className="text-sm font-medium">{label}:</label>}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={widthClasses[width]}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
export default FilterSelect;
